import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalOffering from "@/pages/ClinicalOffering";

export const Route = createFileRoute("/zh-cn/services/clinical-solutions/medical-writing-for-medical-devices")({
  head: () => buildRouteHead("/zh-cn/services/clinical-solutions/medical-writing-for-medical-devices"),
  component: ClinicalOffering,
});

